module.exports = __webpack_public_path__ + "assets/6faa9e5f2a0122d2333fa450337a09b0.js";